<script setup lang="ts">
import { useCardsStore } from '@/stores/cards';

const cardsStore = useCardsStore()
const props = defineProps(['index', 'path', 'classes'])
</script>

<template>
    <div @mouseenter="cardsStore.hoverOver(props.index)"  @mouseleave="cardsStore.hoverOut(props.index)">
        <div class="card_inner">
            <img :src="path" alt="" class="frontplate">
            <img class="backplate" src="/public/Back.jpg">
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
    name: 'SingleCard',
    props: {
        path: String,
        index: Number,
        classes: String
    },
    
    methods: {
        hoverOver() {
            this.$emit('hover', this.index)
            this.$el.classList.remove('rotate_out')

            this.$el.classList.add('rotate_in')

        },
        hoverOut() {
            this.$emit('unhover', this.index)
            this.$el.classList.remove('rotate_in')
            this.$el.classList.add('rotate_out')
        }
    },
    emits: ['hover', 'unhover']

})
</script>

<style scoped>
.card {
    order: var(--index);
    position: relative;
    perspective: 1000px;
    line-height: 0;
    width: auto;
    height: 100px;
    aspect-ratio: 2 / 3;
    --durations: 1s;
}

.card_inner {
    transform-style: preserve-3d;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
    height: 100%;
    border-radius: 5px;
    z-index: 1;
    transition: cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transition-duration: var(--durations);
}
.rotate_all .card.rotate_out .card_inner {
    animation: flip_card_back var(--durations);
}
.rotate_all .card.rotate_in .card_inner {
    animation: flip_card var(--durations);
    transition: cubic-bezier(0.175, 0.885, 0.32, 1.275);
    animation-fill-mode: forwards;
    z-index: 5;
}


.rotate_none .card.rotate_in {
    z-index: 5;
}
.rotate_none .card.rotate_in .card_inner {
    animation: scale_card var(--durations);
    transform: scale3d(2.1, 2.1, 2.1);
    animation-fill-mode: forwards;
    z-index: 5;
}
.rotate_none .card.rotate_out  {
    animation: scale_card_back var(--durations);
    animation-fill-mode: forwards;
    z-index: 1;
}
.card.selected {
    z-index: 10;
    left: 0;
    top: 0;
}
.card.selected .card_inner {
    transition-duration: 4s;
    transform: scale3d(3.1, 3.1, 3.1) rotate3d(1, 1, 0, 720deg);

}
.frontplate, .backplate {
    border-radius: 5px;
    transition: all 1s;
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden; /* Safari */
    backface-visibility: hidden;
    }
img {
    width: 100%;
    height: auto;
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.rotate_all .frontplate {
    transform: rotateY(180deg);

}
.backplate {
    width: 100%;
    height: 100%;
    background-color: yellowgreen;
    object-fit: fill;
    transform: rotateY(180deg);
}
.rotate_all .backplate {
    transform: rotateY(0deg);
}

@keyframes flip_card {
    0% {
        transform: rotateY(0deg);
        transform: translate3d(0, 0, 0);
    }
    50% {
        transform: translate3d(30px, 10px, 0) rotate3d(1, 1, 0, 90deg);
    }
    100% {
        transform: translate3d(0, 0, 0) rotate3d(2, 4, 0, 180deg);
    }
}

@keyframes flip_card_back {
    0% {
        transform: translate3d(0, 0, 0) rotate3d(0, 1, 0, 180deg);
    }
    30% {
        transform: translate3d(-30px, -10px, 0) rotate3d(1, 0, 0, 90deg);
    }
    100% {
        transform: rotateY(0deg);
    }
    
}
@keyframes scale_card {
    0% {
        z-index: 1;
    }

    100% {
        z-index: 5;
    }
}

@keyframes scale_card_back {
    0% {
        z-index: 5;
    }

    100% {
        z-index: 1;
    }
}
</style>